import { render, staticRenderFns } from "./DraggableMenuRow.vue?vue&type=template&id=5611440e&scoped=true"
import script from "./DraggableMenuRow.vue?vue&type=script&lang=js"
export * from "./DraggableMenuRow.vue?vue&type=script&lang=js"
import style0 from "./DraggableMenuRow.vue?vue&type=style&index=0&id=5611440e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5611440e",
  null
  
)

export default component.exports